import { Outlet } from 'react-router-dom';

const SimpleLayout = () => (
  <div className="h-screen">
    <Outlet />
  </div>
);

export default SimpleLayout;
